import { useEffect, useState } from "react";
import { lastMinuteService } from "../../services/lastMinuteService";

// Resolves which of the agent's players are ALREADY on Last Minute (an active
// listing), for the entry-point "On Last Minute · Nd left" state (design 6a).
//
// JOIN KEY: the My-Players list (`playerService.getPlayers`) exposes the player's
// `account_id`, so the map is keyed by that. The owner Mine serializer exposes
// `player_account_id` for exactly this join (BE follow-up); it falls back to
// `player_id` (Player.pk) for callers that key on the pk. Empty until loaded, so
// the button shows by default and swaps to the marker once listings arrive.
export const useMyListedPlayers = (enabled = true) => {
  const [byKey, setByKey] = useState(new Map());

  useEffect(() => {
    if (!enabled) return undefined;
    const controller = new AbortController();
    lastMinuteService
      .getMyListings({ state: "active" }, controller.signal)
      .then((res) => {
        if (!res.success) return;
        const m = new Map();
        res.data.forEach((l) => {
          if (l.listing_type !== "player") return;
          const entry = { id: l.id, expires_at: l.expires_at };
          if (l.player_account_id != null) m.set(l.player_account_id, entry);
          if (l.player_id != null) m.set(l.player_id, entry);
        });
        setByKey(m);
      })
      .catch(() => {});
    return () => controller.abort();
  }, [enabled]);

  return byKey;
};

export default useMyListedPlayers;
